/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getKlaviyoLoyaltyProfileAsync } from './DataActionExtension.g';
import { IProfileModel } from './DataServiceEntities.g';
import { generateCacheKey } from '@msdyn365-commerce-modules/retail-actions';

/**
 * GetKlaviyoProfile Input Action
 */
export class GetKlaviyoProfileInput implements Msdyn365.IActionInput {
    public email: string;
    public apiSettings: Msdyn365.ICommerceApiSettings;

    constructor(email: string, apiSettings: Msdyn365.ICommerceApiSettings) {
        this.email = email;
        this.apiSettings = apiSettings;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => generateCacheKey(this.apiSettings, { key: 'email', value: `${this.email}` });
    public getCacheObjectType = () => 'IProfileModel';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetKlaviyoProfileData {
    IProfileModel: IProfileModel;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const context = args.requestContext;
    const { user, apiSettings } = context;
    if (!user.token || !user.isAuthenticated) {
        throw new Error('[getKlaviyoProfile][createInput]: User is not Authenticated.');
    }

    if (!user.emailAddress) {
        throw new Error('[getKlaviyoProfile][createInput]: User email is missing.');
    }

    const email = user.emailAddress;
    return new GetKlaviyoProfileInput(email, apiSettings);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetKlaviyoProfileInput, ctx: Msdyn365.IActionContext): Promise<IProfileModel> {
    const res = await getKlaviyoLoyaltyProfileAsync({ callerContext: ctx }, input.email);
    if (res) {
        return res;
    }

    throw new Error('Unable to get Klaviyo Profile');
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IProfileModel>>action,
    id: 'GetKlaviyoProfile',
    input: createInput
});
